import React, { useCallback } from 'react'

import { Box, Checkbox, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import { withContext } from '../Context'
import Range from './Range'

const useStyles = makeStyles((theme) => ({
  icon: {
    minWidth: theme.spacing(5),
  },
  border: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
  },
}))

const OPERATION = 'between'

type TestScoreSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
  min: number
  max: number
  rangeStep?: number
  segment: object
  segmentName: string
  label: string
}

export const TestScoreSelector = ({
  criteria = 'OneOf',
  onChange,
  min,
  max,
  rangeStep,
  segment,
  segmentName,
  label = segmentName,
}: TestScoreSelectorProps) => {
  const currentValue = getSegmentValue(segment, criteria, segmentName)
  const [isChecked, setIsChecked] = React.useState(Boolean(currentValue.length))
  const [from, setFrom] = React.useState(currentValue[0] || min)
  const [to, setTo] = React.useState(currentValue[1] || max)
  const classes = useStyles()

  const toggleSegmentValue = useCallback(
    (value: number[]) => {
      onChange(criteria, segmentName, value, OPERATION)
    },
    [onChange, criteria, segmentName],
  )

  return (
    <Box
      my={2}
      className={classes.border}
    >
      <ListItem
        role="listitem"
        aria-label={`Select ${label}`}
      >
        <ListItemIcon className={classes.icon}>
          <Checkbox
            edge="start"
            color="primary"
            checked={isChecked}
            disableRipple={false}
            onChange={() => {
              const value = isChecked ? [] : [from, to]
              setIsChecked(!isChecked)
              toggleSegmentValue(value)
            }}
          />
        </ListItemIcon>
        <ListItemText
          id={'test'}
          primary={<Typography variant="body1">{label}</Typography>}
        />
      </ListItem>
      {isChecked && (
        <Box
          px={2.5}
          pt={2}
          pb={1}
        >
          <Range
            step={rangeStep}
            min={min}
            max={max}
            from={from}
            to={to}
            getAriaValueText={(value: number) => `${label} range: ${value}`}
            onChange={(value: number[]): void => {
              setFrom(value[0])
              setTo(value[1])
              onChange(criteria, segmentName, [value[0], value[1]], OPERATION)
            }}
          />
        </Box>
      )}
    </Box>
  )
}

export default withContext(TestScoreSelector)
